import clsx from "clsx";
import React from "react";
import { CaptionedImage } from "../CaptionedImage/CaptionedImage";
import { ImageGalleryList, ImageGalleryListProps, } from "./ImageGalleryList";
import css from "./image-gallery.module.scss";

export interface ImageGalleryThumb
{
    className?: string;
    galleryId: string;
    style?: React.CSSProperties;
}

interface ImageGalleryThumbPaneProps<Keys extends readonly string[]> extends Omit<ImageGalleryListProps<Keys>, "onGetItem">
{
    items: { [Key in Keys[number]]: ImageGalleryThumb };
}

export const ImageGalleryThumbPane = <Keys extends readonly string[]>({ className, items, ...props }: ImageGalleryThumbPaneProps<Keys>): React.FunctionComponentElement<ImageGalleryThumbPaneProps<Keys>> =>
    <ImageGalleryList
        {...props}
        className={clsx(css["thumb-pane"], className)}
        onGetItem={(key, captionedImageProps) =>
        {
            const { galleryId, className, style } = items[key as Keys[number]];

            return (
                <button className={className} data-image-gallery-id={galleryId} key={key} style={style} type="button" title={""} >
                    <CaptionedImage {...captionedImageProps} />
                </button>
            );
        }}
    />;
